module.exports = __webpack_public_path__ + "img/score-3.2f9d56a3.png";